import type { ImageLoadFailureKind } from '@/types/canvas-type';

/** 保持滑窗顺序，只返回其中可重试的网络失败页。 */
export function getRetryablePageFailureIndexes(
  pageIndexes: readonly number[],
  getFailureKind: (index: number) => ImageLoadFailureKind | undefined
): number[] {
  return pageIndexes.filter((index) => getFailureKind(index) === 'network');
}
